export default __webpack_public_path__ + "static/media/photo-charte05.b9a25349.png";